export const ENGRAVING = 'ENGRAVING';
export const ANNEALING = 'ANNEALING';

export const SET_LASER_OUTPUT_QUALITY = '@/SET_LASER_OUTPUT_QUALITY';